import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.354 4.354a.5.5 0 1 1 .707-.708l7.103 7.104 1.755 1.755 3.162 3.162a.5.5 0 0 1-.707.707z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.75 8.161a3.25 3.25 0 1 0-4-3.238l4 3.998zM10 3.25a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.08 13.252a1.75 1.75 0 0 1 1.668 1.667l.04.04a1.5 1.5 0 1 1-2.122 2.122l-.602-.602a1.76 1.76 0 0 1-.543-.543l-1.684-1.685q-.086.361-.087.749a3.25 3.25 0 1 0 4-3.162v-1.005c0-.42-.144-.828-.45-1.134a1.58 1.58 0 0 0-1.133-.449h-3.088l1.5 1.5h1.588c.04 0 .063.007.071.01h.002l-.002-.002q0-.003 0 0l.002.002.002.001q.003.003 0 0l-.002-.001v.002c.003.008.01.03.01.071v1.005q-.228.054-.444.14z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.762 10.76a.2.2 0 0 1 .071-.01h2.503l-1.5-1.5H5.833c-.42 0-.828.144-1.134.45-.305.305-.449.713-.449 1.133v1.005a3.25 3.25 0 1 0 1.5 0v-1.005c0-.04.007-.063.01-.071v-.002l-.002.002q-.003 0 0 0l.002-.002.001-.002q.003-.003 0 0l-.001.002zM5 13.25a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }